module.exports = __webpack_public_path__ + "img/cog.1543f5ab.svg";